import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=231aae30&scoped=true&"
import script from "./BottomNav.vue?vue&type=script&lang=ts&"
export * from "./BottomNav.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=231aae30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231aae30",
  null
  
)

export default component.exports